// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCompareCarouselStyles } from "@bg/Overrides/Widgets/ProductCompare/ProductCompareCarousel";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import { css } from "styled-components";

productCompareCarouselStyles.navigationLink = {
    css: css`
        margin-top: 12px;
        margin-bottom: 23px;
    `,
    icon: { iconProps: { src: "ArrowLeft", color: "tertiary" } },
    typographyProps: {
        css: css`
            font-size: ${fontConfig.fontSize.regular}px;
            letter-spacing: 0.2px;
            line-height: 16px;
            margin-left: 3px;
        `,
    },
};

productCompareCarouselStyles.removeAllText = {
    color: "tertiary",
    size: fontConfig.fontSize.regular,
    weight: fontConfig.weight.semiBold,
    lineHeight: fontConfig.lineHeight.singleLineSmall,
    css: css`
        letter-spacing: 0.2px;
        opacity: 0.8;
    `,
};
